import { DirectiveBinding } from 'vue/types/options';
import { VNode } from 'vue';

export const outsideClickDirective = {
  bind(el: HTMLElement | any, binding: DirectiveBinding, vnode: VNode | any) {
    el.clickOutsideEvent = (event: Event) => {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el: any) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};

export const focusDirective = {
  inserted(el: HTMLElement, binding: DirectiveBinding) {
    // If directive has bound value
    if (binding.value !== undefined && !binding.value) {
      return;
    }

    // Check if the element is a custom component if so add a focus to the child input
    if (el.nodeName === 'DIV') {
      let inputElement: any = el.querySelectorAll('input, select, textarea')[0];
      if (inputElement) {
        inputElement.focus();
        return;
      }
    }

    el.focus();
  }
};

export const scrollDirective = {
  inserted(el: HTMLElement, binding: DirectiveBinding) {
    const f = (e: Event) => {
      if (binding.value(e, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  }
};
